"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = exports["default"] = exports.accountNavExpanderId = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useKeyPress = _interopRequireDefault(require("../../../utils/use-key-press"));
var _useAnimationState = require("../../../utils/use-animation-state");
var _useFocusTargetIsOutsideContainer = _interopRequireDefault(require("../../../utils/use-focus-target-is-outside-container"));
var _user = _interopRequireDefault(require("../../../icons/user"));
var _caretDown = _interopRequireDefault(require("../../../icons/caret-down"));
var _button = _interopRequireDefault(require("../../button"));
var _icon = _interopRequireDefault(require("../../icon"));
var _navItem = _interopRequireDefault(require("../nav-item"));
var _rule = _interopRequireDefault(require("../../rule"));
require("./desktop-account-nav.css");
var _excluded = ["children", "className", "onClick", "subNavItems"],
  _excluded2 = ["onClick"],
  _excluded3 = ["onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// duration should match animation duration set in CSS
var duration = exports.duration = 200;
var accountNavExpanderId = exports.accountNavExpanderId = 'accountNavExpanderId';

/* eslint-disable max-statements */
/* can simplify this component by breaking it out into a shareable dropdown component.
 * Currently this is YAGNI, but if the desktop links are ever intended to have dropdowns,
 * this work can be leveraged.
 */
var DesktopAccountNav = function DesktopAccountNav(_ref) {
  var accountNav = _ref.accountNav,
    useCrateLayout = _ref.useCrateLayout,
    useMaxWidthLayout = _ref.useMaxWidthLayout,
    signOutButton = _ref.signOutButton;
  var buttonChildren = accountNav.children,
    buttonClassName = accountNav.className,
    onSubNavClick = accountNav.onClick,
    subNavItems = accountNav.subNavItems,
    otherButtonProps = _objectWithoutProperties(accountNav, _excluded);
  // instead of assigning a default value of {} (which is truthy), destructure
  // from an empty object here
  var _ref2 = signOutButton || {},
    buttonOnClick = _ref2.onClick,
    otherSignOutProps = _objectWithoutProperties(_ref2, _excluded2);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubnavOpen = _useState2[0],
    setIsSubnavOpen = _useState2[1];
  var animationState = (0, _useAnimationState.useAnimationState)(isSubnavOpen, duration);
  var escapeKeyPressed = (0, _useKeyPress["default"])({
    targetKeyValue: 'Escape'
  });
  var containerRef = (0, _react.useRef)();
  var buttonRef = (0, _react.useRef)();
  var firstLinkRef = (0, _react.useRef)();
  var focusTargetIsOutsideContainer = (0, _useFocusTargetIsOutsideContainer["default"])(containerRef);
  if (focusTargetIsOutsideContainer && isSubnavOpen) {
    // when keyboard or screenreader user focuses on something outside this component,
    // close the subnav. Will also close if "normal" user clicks or taps on something focusable.
    setIsSubnavOpen(false);
  }
  if (escapeKeyPressed && isSubnavOpen) {
    setIsSubnavOpen(false);
    buttonRef.current && buttonRef.current.focus();
  }
  var toggleSubnav = function toggleSubnav() {
    if (isSubnavOpen) {
      setIsSubnavOpen(false);
    } else {
      setIsSubnavOpen(true);
      // give time for animation to run before focusing
      setTimeout(function () {
        firstLinkRef.current && firstLinkRef.current.focus();
      }, duration);
    }
  };
  var linkClass = "sb-desktopAccountNav__link ".concat(useCrateLayout ? 'sb-desktopAccountNav--crateLayout' : '', " block text-noUnderline px5 py3");
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    "aria-controls": accountNavExpanderId,
    "aria-expanded": isSubnavOpen,
    "aria-haspopup": true,
    className: "text-noUnderline text-semibold ".concat(buttonClassName || ''),
    color: "black",
    onClick: function onClick(e) {
      toggleSubnav();
      onSubNavClick && onSubNavClick(e);
    },
    visualStyle: "textLink"
  }, otherButtonProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "mr2",
    path: _user["default"],
    size: "22px"
  }), buttonChildren, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: (0, _classnames["default"])('sb-accountChevron color-textBlackSoft ml2', {
      'sb-accountChevron--expanded': isSubnavOpen
    }),
    path: _caretDown["default"]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-desktopAccountNav__position sb-global-gutters', {
      'sb-desktopAccountNav__positionMaxWidth': useMaxWidthLayout
    }),
    id: accountNavExpanderId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-desktopAccountNav__submenuSlider', {
      hidden: animationState === _useAnimationState.states.closed,
      'sb-desktopAccountNav__submenu--opening block': animationState === _useAnimationState.states.opening,
      'sb-desktopAccountNav__submenu--closing block': animationState === _useAnimationState.states.closing
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-desktopAccountNav__submenu py3 ".concat(useCrateLayout ? 'bg-white' : 'bg-neutralCool')
  }, /*#__PURE__*/_react["default"].createElement("ul", null, subNavItems.map(function (item, i) {
    var _onClick = item.onClick,
      otherProps = _objectWithoutProperties(item, _excluded3);
    return /*#__PURE__*/_react["default"].createElement(_navItem["default"], _extends({
      key: i,
      linkClassName: linkClass,
      linkRef: i === 0 ? firstLinkRef : null,
      onClick: function onClick(e) {
        setIsSubnavOpen(false);
        _onClick && _onClick(e);
      }
    }, otherProps));
  }), signOutButton && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_rule["default"], {
    className: "px5 py3"
  }), /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    className: "".concat(linkClass, " size12of12"),
    onClick: function onClick(e) {
      setIsSubnavOpen(false);
      buttonOnClick && buttonOnClick(e);
    },
    visualStyle: "textLink"
  }, otherSignOutProps))))))));
};
var _default = exports["default"] = DesktopAccountNav;